import { render, staticRenderFns } from "./OurWorksSlider.vue?vue&type=template&id=299aaad5&scoped=true&"
import script from "./OurWorksSlider.vue?vue&type=script&lang=ts&"
export * from "./OurWorksSlider.vue?vue&type=script&lang=ts&"
import style0 from "./OurWorksSlider.vue?vue&type=style&index=0&id=299aaad5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299aaad5",
  null
  
)

export default component.exports